module.exports = __webpack_public_path__ + "static/media/telephone.5f3b84b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/telephone.svg
// module id = 1012
// module chunks = 0